import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from '../FontIcon';
import './TrashIcon.css';

function TrashIcon({ className, size = 'base', title, alt, filled, disabled }) {
  return (
    <FontIcon
      icon="trash"
      className={`trash-icon ${className || ''} ${size}`}
      title={title}
      alt={alt}
      filled={filled}
      disabled={disabled}
    />
  );
}

TrashIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default TrashIcon;
